const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    banner: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {

        case 'BANNER_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                banner: action.payload
        };

        case 'BANNER_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                banner: action.payload,
            };
        case 'SET_CURRENT_BANNER':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                banner: action.payload
            };

        case 'BANNER_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}